import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["fieldSelect", "stringInput", "multiInput", "multiSelect"]

  connect() {
    this.updateInputs()
  }

  updateInputs() {
    const option    = this.fieldSelectTarget.selectedOptions[0]
    const fieldType = option ? option.dataset.fieldType : null
    const optsAttr  = option ? option.dataset.options : null

    this.stringInputTarget.classList.add('d-none')
    this.multiInputTarget.classList.add('d-none')
    this.stringInputTarget.querySelector('input, textarea').disabled = true
    this.multiSelectTarget.disabled = true

    if (fieldType === "string") {
      this.stringInputTarget.classList.remove('d-none')
      this.stringInputTarget.querySelector('input, textarea').disabled = false
    } else if (fieldType === "multi") {
      this.multiInputTarget.classList.remove('d-none')
      this.multiSelectTarget.disabled = false
      this.populateMultiOptions(optsAttr)
    }
  }

  populateMultiOptions(optsAttr) {
    const select = this.multiSelectTarget
    select.innerHTML = ''
    const blank = document.createElement('option')
    blank.value = ''
    blank.textContent = '—'
    select.appendChild(blank)

    if (!optsAttr) return

    let options
    try { options = JSON.parse(optsAttr) } catch (e) { return }

    options.forEach((opt) => {
      const el = document.createElement('option')
      el.value = opt
      el.textContent = opt
      select.appendChild(el)
    })
  }
}
